import {getId} from 'apis/model/base'
import _ from 'lodash'
import React, {useMemo} from 'react'
import {NullAsDefault, renderSelf} from 'views/Shared'
import {bindQueryParams} from '../../functions/routerHelper'
import {timetable_getMilestonesByDepartment_Api} from 'apis'
import {BsInboxesFill} from 'react-icons/bs'
import useTranslate from 'modules/local/useTranslate'
import {ActionModalWrapper} from 'components/form/ActionModalWrapper'
import {useTimetableOrganizationForm} from 'views/AppLocals/Timetable/useTimetableOrganizationForm'
import {renderTimetableItem} from 'views/AppLocals/Timetable/TimetableForm'
import usePaginationHelper, {createPagerKey} from 'views/AppLocals/hooks/usePaginationHelper'
import {
    createTimetableFilterActions,
    resolveTimetableStatusFilter,
    TimetableScheduleFilter,
} from 'views/AppLocals/Timetable/TimetableScheduleFilter'
import {useRouteSearchParam} from 'envs/_current/history'
import {useLocation} from 'react-use'

const filterActions = createTimetableFilterActions('dept-tt')

export const OrganizationTimetables = ({
                                           item: organizationGroup,
                                           header = null,
                                           renderFooter = renderSelf,
                                       }) => {
    const t = useTranslate()
    const location = useLocation()
    const {
        modal,
        renderContextMenu,
        refreshKey: formRefreshKey
    } = useTimetableOrganizationForm({
        organizationGroup: organizationGroup,
        organization: organizationGroup?.organization,
    })
    const groupId = getId(organizationGroup)

    const keyword = useRouteSearchParam(filterActions.keyword)
    const from_time_open = useRouteSearchParam(filterActions.from_time_open)
    const to_time_open = useRouteSearchParam(filterActions.to_time_open)
    const include_expired = useRouteSearchParam(filterActions.include_expired)
    const status = resolveTimetableStatusFilter(include_expired)

    const refresh_deps = useMemo(
        () => [
            groupId,
            keyword,
            from_time_open,
            to_time_open,
            status,
            formRefreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [groupId, keyword, from_time_open, to_time_open, status, formRefreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        pagerInfo: {
            RenderEntity: React.Fragment,
            PaginationMeta: NullAsDefault,
            apiInfo: timetable_getMilestonesByDepartment_Api,
            query: bindQueryParams([{id: groupId}]),
            renderItem: renderTimetableItem({renderContextMenu}),
            renderWrap: (child) => (
                <div className="flex flex-col divide-y divide-gray-200 list-item-workspace">
                    {child}
                </div>
            ),
            renderEmpty: () => (
                <div
                    className="p-6 flex flex-col items-center gap-3 border border-color-50 rounded-xl shadow-md">
                    <BsInboxesFill size={40} style={{color: '#dedede'}}/>
                    <span className="text-center text-sm text-color-300 tracking-wider italic">
                        {t('no data is available now')}
                    </span>
                </div>
            ),
        },
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        isToggleDefault: true,
        query_params: filterActions,
        onInit: ({onFilterChange = NullAsDefault}) => {
            onFilterChange({keyword, from_time_open, to_time_open, status})
        },
        filter_params: {keyword, from_time_open, to_time_open, status},
        dependencies: [groupId, keyword, from_time_open, to_time_open, status, formRefreshKey],
        withKey: createPagerKey(refresh_deps),
        AdvancedFilter: TimetableScheduleFilter,
        renderHeader: ([searchBar]) => searchBar,
    })

    return (
        <ActionModalWrapper className="flex-1">
            {header}
            <div className="mt-6 flex flex-col gap-1">
                <div className="font-bold text-base text-gray-700 tracking-wide uppercase">
                    {t('detail timetable')}
                </div>
                <div className="mt-3 flex flex-col gap-4">
                    {!!organizationGroup?.id && pager_widget}
                </div>
            </div>
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}
